'use strict';

import { Loader } from '@googlemaps/js-api-loader';
import './LocationsMap.css';

declare global {
    interface LocationsConfig {
        center: {
            lat: number,
            lng: number
        },
        key?: string,
        locations: [{
            url: string,
            title: string,
            lat: number,
            lng: number,
            iconPath: string
        }]
    }
  
    interface Window {
      locationsConfig: LocationsConfig,
      initMap: () => void;
    }
}

function locationsMap() {
    const mapContainer = document.querySelector('[data-locations-map]');
    const config = window.locationsConfig;

    const loader = new Loader({
        apiKey: `${config.key}`,
        version: "weekly",
        libraries: ["places"]
      });

    loader
        .load()
        .then((google) => {
            if(mapContainer instanceof HTMLElement) {
                const bounds = new google.maps.LatLngBounds();
                const map = new google.maps.Map(mapContainer, {
                    zoom: 11,
                    mapId: '808caf60360c6185',
                    center: { lat: config.center.lat, lng: config.center.lng },
                    zoomControl: false,
                    disableDefaultUI: true
                });
                for (const talbertLocation of config.locations) {
                    const marker = new google.maps.Marker({
                        position: new google.maps.LatLng(talbertLocation.lat, talbertLocation.lng),
                        title: talbertLocation.title,
                        label: {
                            fontFamily: 'Cera Pro',
                            fontWeight: '500',
                            fontSize: '18px',
                            color: '#5C5C5C',
                            text: talbertLocation.title,
                        },
                        icon: {
                            path: talbertLocation.iconPath,
                            fillColor: "#936700",
                            fillOpacity: 1,
                            strokeWeight: 0,
                            rotation: 0,
                            scale: 0.85,
                            anchor: new google.maps.Point(10, 20),
                            labelOrigin: new google.maps.Point(20, 70),
                        },
                        map: map,
                        draggable: false,
                        
                    });
                    bounds.extend(new google.maps.LatLng(talbertLocation.lat, talbertLocation.lng));
                    // Add Pinehurst to map
                    const pinehurst = new google.maps.LatLng(config.center.lat, config.center.lng);
                    bounds.extend(pinehurst);
                    google.maps.event.addListener(marker, 'click', () => {
                        window.location.href = talbertLocation.url
                    });
                }
                map.fitBounds(bounds);
            }
        })
        .catch(e => {
            throw new Error('Could not load map properly', e);
        });
}

export default locationsMap;